// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import steps from '../../../../Common/Onboarding/first_steps.json'
import './SlideStyles.css'

function FirstStepsSlide({ stepId }: { stepId: string }) {
  const step = steps.find(item => item.id === stepId)!
  const index = steps.indexOf(step)
  return (
    <div className="slide-content centered first-steps-slide">
      <div className="feature-category">Try it yourself · {index + 1} of {steps.length}</div>
      <h2 className="slide-title">{step.title}</h2>
      <p className="slide-text large">{step.instructions}</p>
      <div className="first-steps-example" aria-label="Example file workflow">
        <strong>Project notes.docx</strong>
        <span>{stepId === 'tag' ? 'Tag: Kitchen renovation' : stepId === 'find' ? 'Search filters → Tags → Kitchen renovation' : 'Comment: Check these figures before submitting.'}</span>
      </div>
      <p className="slide-text">{step.extra}</p>
      <p className="slide-note">Resume this checklist in Settings → Welcome → Try these first.</p>
    </div>
  )
}

export default FirstStepsSlide
